import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import { useSelector } from "react-redux";
import {
  AddCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  ProfileAdd,
  Trash,
} from "iconsax-react";
import { useLocation } from "react-router-dom";

function MyOthers(props) {
  const [brandList, setbrandList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get("id");

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Name <br />
        </div>
      ),
      selector: (row) => row.other_name,
    },

    {
      name: "Subject",
      selector: (row) => row.subject,
    },
    {
      name: "Contact Name",
      selector: (row) => row.contact_name,
    },
    {
      name: "Contact Number",
      selector: (row) => row.contact_no,
    },
    // {
    //   name: "Employees",
    //   selector: (row) =>
    //     (row.emp_details || []).map((emp) => emp.full_name).join(", ") || "—",
    // },

    {
      name: "Total Amount",
      selector: (row) => row.total_amt,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button className="btn btn-flat me-1" onClick={handleView(row)}>
            <Eye />
          </RB.Button>
        </>
      ),
    },
  ];

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getOthers();
  }, [page, filterText,id]);

  const getOthers = () => {
    utils
      .callAPI(
        "get",
        `/meeting/others/list-keypersion?id=${
          id ? id : ""
        }&page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setbrandList(res);
          if (id) {
            const found = res.result.find(
              (item) => Number(item.id) === Number(id)
            );
            if (found) {
              props.onChange({
                mode: "view",
                rowData: found,
              });
            }
          }
        } else {
          setbrandList([]);
        }
      })
      .catch((err) => {
        setbrandList([]);
      });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleDownload = () => {
    // quick date formatter for "YYYY-MM-DD HH:mm:ss" -> "DD-MM-YYYY"
    const formatDMY = (s) => {
      if (!s || typeof s !== "string") return "";
      const ymd = s.slice(0, 10); // "YYYY-MM-DD"
      const [y, m, d] = ymd.split("-");
      if (!y || !m || !d) return "";
      return `${d}-${m}-${y}`;
    };

    const esc = (v) => `${v ?? ""}`.replace(/"/g, '""'); // CSV-escape quotes

    utils
      .callAPI("get", `/meeting/others/list-keypersion?page=0&per_page=0`)
      .then((res) => {
        const rows = Array.isArray(res?.result) ? res.result : [];
        if (!rows.length) {
          return;
        }

        // Header (exact order requested)
        const header = [
          "Requested Date",
          "Other Name",
          "State",
          "District",
          "City",
          "Subject",
          // "Employee Name (comma separated)",          
          "Total",
        ].join(",");

        const csvRows = rows.map((r) => {
          const requestedDate = formatDMY(r.createdAt);
          const otherName = r.other_name || "";
          const state = r.state_name || r.state || "";
          const district = r.district_name || r.district || "";
          const city = r.city_name || r.city || "";
          const subject = r.subject || "";
          const employees = (r.emp_details || [])
            .map((e) => e.full_name)
            .filter(Boolean)
            .join(", ");
          const total = r.total_amt || "";

          return [
            `"${esc(requestedDate)}"`,
            `"${esc(otherName)}"`,
            `"${esc(state)}"`,
            `"${esc(district)}"`,
            `"${esc(city)}"`,
            `"${esc(subject)}"`,
            `"${esc(employees)}"`,
            `"${esc(total)}"`,
          ].join(",");
        });

        const csvContent = [header, ...csvRows].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const ts = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", "_")
          .replace(/:/g, "-");

        link.href = URL.createObjectURL(blob);
        link.download = `MyOthers.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {});
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            <a
              href
              className={`${
                brandList.result?.length ? "" : "disabled"
              } btn btn-primary btn-circle ms-2`}
              variant="primary"
              onClick={handleDownload}
            >
              <DocumentDownload />
            </a>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <DataTable
            columns={columns}
            data={brandList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={brandList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={brandList.total}
                rowsPerPage={countPerPage}
                onPageChange={handlePageChange}
              />
            )}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem", // Adjust the font size as needed
                  fontWeight: "bold", // Adjust the font weight as needed
                },
              },
            }}
          />
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default MyOthers;
